// header.js
class Header {
  constructor() {
    this.pageSettings = drupalSettings?.header_settings?.page_settings || {};
    this.currentScrollTop = 0;
    this.navbar = document.querySelector('.noahs-theme--header--pro');
    this.headerHeight = this.navbar ? this.navbar.offsetHeight : 0;
    this.hideOnScrollDown = this.pageSettings.hide_on_scroll_down === 'on';
    this.boundOnScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.boundOnScroll, { passive: true });
    this.onScroll();
  }

  onScroll() {
    const scrollTop = window.scrollY;
    let transformValue = 'translateY(0)';

    if (this.hideOnScrollDown) {
      if (this.currentScrollTop < scrollTop && scrollTop > this.headerHeight * 2) {
        transformValue = `translateY(${-this.headerHeight}px)`;
      } else if (this.currentScrollTop > scrollTop && !(scrollTop <= this.headerHeight)) {
        transformValue = 'translateY(0)';
      }
    }

    if (this.navbar) {
      this.navbar.style.transform = transformValue; 
    }

    if (scrollTop >= this.headerHeight) {
      this.navbar?.classList.add('sticky');
    } else {
      this.navbar?.classList.remove('sticky');
    }

    this.currentScrollTop = scrollTop;
  }

  destroy() {
    window.removeEventListener('scroll', this.boundOnScroll);
    this.navbar?.classList.remove('sticky');
    if (this.navbar) this.navbar.style.removeProperty('transform');
  }
}

// Exportar la clase Header para poder importarla en otro archivo
export default Header;
